import { Schema as UserParamsSchema } from 'App/Users/UserList/schema';

import { User } from 'core/types/user';

import usePaginationHandler from './usePaginationHandler';

export default function useUsers(params: UserParamsSchema) {
  return usePaginationHandler<User>('users', params);
}
